module.exports = __webpack_public_path__ + "img/thumbnail_Wolverine_m_albino.ebf718e8.png";